/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import { shape, string, object, bool, array, func } from 'prop-types';
import { connect } from 'react-redux';

import Form from 'components/Form/Form';

/**
 * This is the RequestCode component class.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
const RequestCode = ({ requestCodeForm, onSubmit }) => (
  <Form {...requestCodeForm} onSubmit={onSubmit} />
);

/**
 * Declare expected prop types.
 *
 * @type {Object}
 */
RequestCode.propTypes = {
  requestCodeForm: shape({
    fieldsets: array.isRequired,
    validationMessages: object.isRequired,
    submitText: string.isRequired,
    sending: bool.isRequired,
    errors: object.isRequired,
  }).isRequired,
  onSubmit: func.isRequired,
};

/**
 * Declare default props.
 *
 * @type {Object}
 */
RequestCode.defaultProps = {};

export default connect(({ requestCodeForm }) => ({ requestCodeForm }))(
  RequestCode
);
